/**
 * This service is in charge of making all the requests for the legacy module. Since the idea is
 * to eventually remove everything legacy-related, the requests are not declared on the `appAPI`
 * service itself, instead, this service makes use of its methods for request types (`get`,
 * `post`, `put`, etc.) and endpoint building (`endpoint`).
 * @ngesdoc service
 * @ngname legacy
 * @ngmodule legacy
 * @ngrequires common
 */
class Legacy {
  /**
   * @param {AppAPI} appAPI To access the methods for request types and endpoint building.
   */
  constructor(appAPI) {
    'ngInject';

    /**
     * A local reference for the `appAPI` service.
     * @type {AppAPI}
     */
    this.appAPI = appAPI;
  }
  /**
   * Sends a request to reset the user password.
   * @param {string}  email   The user email address.
   * @param {string}  referer The URL of a valid Olapic application.
   * @return {Promise<Object,Error>}
   */
  rememberPassword(email, referer) {
    return this.appAPI.post(
      this.appAPI.endpoint('legacy.rememberPassword'),
      {
        email,
        referer,
      },
    );
  }
}

export default Legacy;
